"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var QuoteBlockStore_1 = __importDefault(require("QuoteV2/Stores/QuoteBlockStore"));
var react_1 = __importDefault(require("react"));
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var ContextMenu_1 = __importDefault(require("./ContextMenu/ContextMenu"));
var DiscountPanel_1 = __importDefault(require("./DiscountPanel"));
var TotalMenu = (function (_super) {
    __extends(TotalMenu, _super);
    function TotalMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TotalMenu.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: 10 }, function () { return (react_1.default.createElement(ContextMenu_1.default, { button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({}, buttonProps, { icon: react_1.default.createElement(icons_1.Edit, { className: "total-menu__edit" }), type: kaleidoscope_1.ButtonType.Tertiary, tooltip: { content: "Total options" } }))); }, items: [
                {
                    label: "Discount",
                    panelContents: (react_1.default.createElement(DiscountPanel_1.default, { discountStore: _this.quote.discount, telemetryHierarchy: QuoteTelemetry_1.QuoteTelemetryHierarchy.Total })),
                },
                {
                    label: "Properties",
                    panelContents: (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Show total discounts", value: _this.quote.showTotalDiscounts, onChange: function (isActive) {
                                _this.quote.showTotalDiscounts = isActive;
                            } }))),
                },
                {
                    label: "Tax",
                    panelContents: (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Show tax totals", value: _this.quote.showTaxTotals, onChange: function (show) {
                                _this.quote.showTaxTotals = show;
                            } }),
                        react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Show total excluding tax", value: _this.quote.showTotalExcludingTaxes, onChange: function (show) {
                                _this.quote.showTotalExcludingTaxes = show;
                            } }))),
                },
            ] })); }));
    };
    var _a;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof QuoteBlockStore_1.default !== "undefined" && QuoteBlockStore_1.default) === "function" ? _a : Object)
    ], TotalMenu.prototype, "quote", void 0);
    TotalMenu = __decorate([
        mobx_react_1.observer
    ], TotalMenu);
    return TotalMenu;
}(react_1.default.Component));
exports.default = TotalMenu;
